import getEnvironment from 'env-config/get-environment';

export function getSubdomain(): string {
    const urlSplit = window.location.host.split('.');
    if (window.location.host.includes('localhost') && urlSplit.length === 1) {
        return getEnvironment().defaultSubdomain;
    }
    return urlSplit[0];
}
